import React, { useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import { ReactComponent as PortfolioHovered } from './img/hovered-icon.svg';
import { ReactComponent as Edit } from '../../../assets/edit-icon.svg';
import { ReactComponent as Delete } from '../../../assets/delete-black-icon.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Row } from 'antd';

import {
  numberWithSpaces,
  numberWithSpacesInter,
} from '../../../helpers/formatInteger';

import fadeDark from './img/fade-composite.png';
import fadeLight from './img/fade-composite-light.png';
import glass from './img/glass-composite.svg';

import './style.scss';
import ModalDeletePortfolio from '../../../components/ModalDeletePortfolio/ModalDeletePortfolio';
import { useSelector } from 'react-redux';

export const ColorDataItem = ({ text, value, isSelected }) => (
  <div className="portfolio-card-item ">
    <span
      className={`portfolio-card-item-title ${isSelected ? 'selected' : ''}`}
    >
      {text}
    </span>
    <span
      className={`portfolio-card-item-value ${value >= 0 ? 'green' : 'red'}`}
    >
      {value > 0 ? '+' : ''}
      {value ? numberWithSpacesInter(value, 2) : '-'}%
    </span>
  </div>
);

const ClientPortfolioCompositetem = ({
  item = null,
  selectedRowKeys,
  setSelectedRowKeys,
  theme,
  userId,
}) => {
  // const { t } = useTranslation('');
  const [isHovered, setIsHovered] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { name, total_value, is_composite } = item ?? {};

  const [modalDeleteVisible, setModalDeleteVisible] = useState(false);
  const {
    portfolioList: { list: portfolioList },
  } = useSelector((state) => state.portfolioReducer);

  const getPortfolio = (id) => {
    return portfolioList?.find((i) => i.id === id);
  };

  const isSelecte = useMemo(() => {
    return selectedRowKeys === item?.id;
  }, [selectedRowKeys, item]);

  const onClickItem = () => {
    if (item) {
      setSelectedRowKeys(item?.id);
    } else {
      setSelectedRowKeys(null);
      history.push(`${location.pathname}/composite/${item?.id ?? 'create'}`);
    }
  };

  const backgroundSelected = useMemo(() => {
    const color = theme === 'dark-theme' ? '#2D2624' : '#F6F4F3';
    const fade = theme === 'dark-theme' ? fadeDark : fadeLight;

    return `url(${fade}), no-repeat url(${glass}), ${color}`;
  }, [theme, item]);

  const hendleEdit = (id) => {
    history.push(`${location.pathname}/composite/${id}/includes`);
  };

  const totalValue = useMemo(() => {
    console.log('🚀 ~ ClientPortfolioCompositetem ~ item:', item);
    if (item) {
      let total = 0;
      item.composites.forEach((el) => {
        const portfolio = getPortfolio(el);
        total += portfolio?.total_value ?? 0;
      });
      return total;
    } else {
      return 0;
    }
  }, [item, portfolioList]);

  const handleDelete = () => {
    setModalDeleteVisible(true);
  };

  return (
    <div
      onClick={onClickItem}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: isSelecte || isHovered ? backgroundSelected : undefined,
      }}
      className={`client portfolio-card ${!isSelecte ? 'unselected' : 'selected'}`}
    >
      <div>
        <p className="portfolio-card-icons">
          {isSelecte ? (
            <div className="cell-button-wrapper">
              <Button type="text" onClick={() => hendleEdit(item.id)}>
                <Edit />
              </Button>
              <Button type="text" onClick={() => handleDelete(item.id)}>
                <Delete />
              </Button>
            </div>
          ) : (
            <PortfolioHovered />
          )}
        </p>
        <p className="portfolio-card-name">{item ? name : 'My Total Wealth'}</p>
      </div>
      <div>
        <p className="portfolio-card-value">{`${item ? numberWithSpaces(Math.round(total_value || totalValue)) : '0'} kr`}</p>
        <Row
          justify={'center'}
          className="portfolio-card-text"
          style={{ height: '24px' }}
        ></Row>
      </div>
      {item && (
        <ModalDeletePortfolio
          modalDeleteVisible={modalDeleteVisible}
          setModalDeleteVisible={setModalDeleteVisible}
          portfolioId={item?.id}
          userId={userId}
          name={name}
          is_composite={is_composite}
        />
      )}
    </div>
  );
};

export default ClientPortfolioCompositetem;

ClientPortfolioCompositetem.propTypes = {
  item: PropTypes.object,
  selectedRowKeys: PropTypes.number,
  setSelectedRowKeys: PropTypes.func,
  theme: PropTypes.string,
  userId: PropTypes.string,
};

ColorDataItem.propTypes = {
  text: PropTypes.string,
  value: PropTypes.number,
  isSelected: PropTypes.bool,
};
